export const REJECT_ACTION = 'REJECT';
export const APPROVE_ACTION = 'APPROVE';
